{
  "version": 1,
  "asset_id": "be031197-b496-4719-b87f-db82f51c8b44",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/be031197-b496-4719-b87f-db82f51c8b44/lap-band-removed-1200.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/be031197-b496-4719-b87f-db82f51c8b44/lap-band-removed-1200.jpg",
  "original_filename": "lap-band-removed-1200.jpg",
  "size": 148309,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T00:12:08Z"
}
